import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  constructor() {}

  private storageSub = new Subject<String>();

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  setSavedState<T>(state: T, localStorageKey: string) {
    localStorage.setItem(localStorageKey, JSON.stringify(state));
    this.storageSub.next('local storage has been updated');
  }

  getSavedStateWithDefaultValue<T extends object>(
    localStorageKey: string,
    defaultValue: object,
  ): T {
    return {
      ...defaultValue,
      ...(localStorage.hasOwnProperty(localStorageKey)
        ? JSON.parse(localStorage.getItem(localStorageKey))
        : {}),
    };
  }

  getSavedState<T>(localStorageKey: string): T {
    return JSON.parse(localStorage.getItem(localStorageKey));
  }

  remove(localStorageKey: string): void {
    this.storageSub.next('local storage has been updated');
    return localStorage.removeItem(localStorageKey);
  }
}
